const KeyMirror = require("keymirror");

module.exports = KeyMirror({
    USER_FETCH_BEGIN: true,
    USER_FETCH_SUCCESS: true,
    USER_FETCH_FAIL: true,
    REGISTRATION_BEGIN: true,
    REGISTRATION_SUCCESS: true,
    REGISTRATION_FAIL: true,
    UPDATE_EMAIL_BEGIN: true,
    UPDATE_EMAIL_SUCCESS: true,
    UPDATE_EMAIL_FAIL: true
});



// WEBPACK FOOTER //
// ./src/action-types/auth.js